
import { Component } from '@angular/core';
import { ProjectPagehearderComponent } from "../project-pagehearder/project-pagehearder.component";
import { SubmenuComponent } from '../shared/components/submenu/submenu.component';
import { ProjectService } from '../shared/services/project.service';

@Component({
  selector: 'app-project-submenu',
  imports: [SubmenuComponent, ProjectPagehearderComponent],
  templateUrl: './project-submenu.component.html',
  styleUrl: './project-submenu.component.scss'
})
export class ProjectSubmenuComponent {
  protected translationMap: Map<string, string> = new Map<string, string>([
    ["to-project-home", $localize`:@@to-project-home:Projekt Home`],
    ["to-project-managemen-menu", $localize`:@@to-project-managemen-menu:Freigabeverwaltung`],
    ["to-project-secrets", $localize`:@@to-project-secrets:Projekt-Secrets`],
    ["to-project-documents", $localize`:@@to-project-documents:Projekt Dokumente`],
    ["to-project-apitoken", $localize`:@@to-project-apitoken:Projekt API`],
    ["to-project-keyvals", $localize`:@@to-project-keyvals:Projekt Datenspeicher`],
    ["to-project-bot-communication", $localize`:@@to-project-bot-communication:Bot-Gruppenchat`],
    ["to-project-quiz", $localize`:@@to-project-quiz:Quiz-Verlauf`]
  ]);
  constructor(public projectService: ProjectService) {
  }
}
